import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { PHBHPFeaturePackageSOPManagementService } from '../ph-bhp-feature-package-sopmanagement.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { sop, stepCards } from '../ph-bhp-manage-sop/sop';
import { HandDisinfectionIndicators, ImageLibrary, SopStep } from '../Models';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { generate, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { openTranslationModal } from '../translation.utilities';
import { ChangedTranslationValue } from '../dynamic-translation-dialog/dynamic-translation-dialog.component';
import { LoggingService } from 'src/app/services/logging.service';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-sop-step',
  templateUrl: './ph-bhp-sop-step.component.html',
  styleUrls: ['./ph-bhp-sop-step.component.css']
})

export class PhBhpSopStepComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  imageUpload: Subscription;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  ImageIndex: number;
  activeClass: any = {};
  updateSubmitted = false;
  isUpdate = true;
  searchText: string;
  ImageData: Array<ImageLibrary>;
  ImageTags: any = [];
  collapseExample = false;
  tooltipImage: any = {};
  institutionID;
  InstitutionImageData: any;
  @Input() sopStep: SopStep = sop();
  @Input() isDesktop = true;
  @Input() viewType;
  @Input() institutions;
  @Output() childData = new EventEmitter();
  @Input() roleId: number;
  @Input() userData;
  @ViewChild('sopWrapper') sopWrapper;
  @ViewChild('sopimageTooltipPos') sopimageTooltipPos;
  @ViewChild('arrw') arrw;
  @ViewChild('arrwShadow') arrwShadow;
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChildren('modelStepTittle') modelStepTittle;
  @ViewChild('modelSubProcessTitle') modelSubProcessTitle;
  @ViewChild('confirmModal') confirmModal: TemplateRef<any>;
  @Input() handDisinfectionIndicators: HandDisinfectionIndicators;
  @Input() sopId: number;
  @Input() sopVersionNo: number;
  showAddImage: boolean;
  situationalCommentsMaxLength = 1000;
  optiontitleMaxlength = 150;
  index: any;
  deleteSubIndex: number;
  isSubStep = false;
  deleteindex: boolean;
  @Input() subStepDisable = false;
  tooltipcloseMob = false;
  tooltipMaskMob = false;
  isSubprocess = false;
  currentSOPsteps;
  Retainsubstep = false;
  currentDefaultImage;
  selectedStepCard: number;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  previousData: any = {};
  constructor(private modalService: BsModalService, public service: PHBHPFeaturePackageSOPManagementService, public layoutService: PHBHPLayoutPackageService, public translate: TranslateService, private logging: LoggingService) { }

  ngOnInit() {
    if (this.layoutService.institutionID) {
      this.institutionID = this.layoutService.institutionID;
      this.InstitutionImageUploader();
    }

    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((id) => {
      this.institutionID = id;
      this.InstitutionImageUploader();
    });
    this.imageUpload = this.service.imageUploadedFromMobile.asObservable().subscribe(() => {
      this.InstitutionImageUploader();
    });
    this.service.getImageLibraries().subscribe((res: Array<ImageLibrary>) => {
      this.ImageData = res;
      for (let i = 0; i < this.ImageData.length; i++) {
        try {
          this.ImageData[i].tags = JSON.parse(this.ImageData[i].tags);
        } catch (e) {
          this.logging.logError(e.message, e)
        }
      }
    });
    this.showAddImage = (!this.isDesktop && (this.roleId === 4));
    // this.showAddImage = true;

    this.updateInputs(this.index);
  }
  InstitutionImageUploader() {
    let roleId = this.userData.roleName.roleId;
    if (roleId > 2) {
      if (this.layoutService.groupID && roleId !== 3) {
        this.institutions = this.institutions + ',' + this.layoutService.groupID;
      }
      this.service.InstitutionAdminImageUploader(this.institutions, roleId).subscribe(res => {
        this.InstitutionImageData = res;
        for (let i = 0; i < this.InstitutionImageData.length; i++) {
          this.InstitutionImageData[i].tags = JSON.parse(this.InstitutionImageData[i].tags);
        }
      });
    }
  }
  openTranslationModal(key: string, fieldName: string, isMultiLine = false, maxlength: number = 150) {
    this.service.getTranslationsFromKey(key).subscribe((result: { language: string, value: string }) => {
      const modalRef = openTranslationModal(this.modalService, key, result, fieldName, isMultiLine, maxlength);
      modalRef.content.subject$.subscribe((data: ChangedTranslationValue[]) => {
        const request = {};
        for (let index = 0; index < data.length; index++) {
          request[data[index].language] = data[index].value;
        }

        if (data && data.length > 0) {
          this.service.patchTranslation(key, request).subscribe(() => {
            const langs = this.translate.getLangs();
            // for each value in request where the language is defined in langs call this.translate.set(key, value, lang);
            for (const lang of langs) {
              if (request[lang]) {
                this.translate.set(key, request[lang], lang);
              }
            }
          }, e => this.logging.logError(e.message, e));
        }
      });
    });
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // TODO extract image library modal from sop step component instead of referencing it here directly
  openModal(index) {
    if (this.viewType === 'view') {
      return false;
    }
    this.ImageIndex = index;
    this.activeClass = {};
    // Save the previous image to be used in case of cancel
    if (index != null) {
      this.previousData = {
        image: this.sopStep.stepCards[index].stepImage,
        index
      };
    }
    this.modalRef = this.modalService.show(this.template, Object.assign({}, { class: 'modal-lg w-auto imageLibraryModal' }));
  }
  toggleSingleSOP() {
    // this.cdkDragList.forEach(cdkDrag => cdkDrag.nativeElement.classList.remove('active'));
    if (this.isDesktop) {
      this.service.isCollapsed = !this.service.isCollapsed;
      this.childData.emit({ val: this.isSubprocess, action: 'stepUpdate' });
    } else {
      this.childData.emit({ key: 'closePopup', val: this.isSubprocess, action: 'stepUpdate' });
    }
  }

  closePopup() {
    if (this.isDesktop) {
      this.service.isCollapsed = !this.service.isCollapsed;
      this.childData.emit({ val: this.isSubprocess });
    } else {
      this.childData.emit({ key: 'closePopup', val: this.isSubprocess });
    }
  }

  stepTypeRadio(click) {

    this.Retainsubstep = false;
    this.currentSOPsteps = this.sopStep.stepCards;
    this.currentDefaultImage = this.sopStep.useStepImage;
    this.isSubStep = click;
    if (click) {
      this.isSubStep = click;
      this.sopStep.stepType = click;
      if (this.sopStep.stepCards.length <= 1) {
        this.sopStep.stepCards.push(stepCards());
      }

      this.sopStep.stepCards.forEach((card, i) => {
        card.stepTittle = this.generateSopSubStepKey(this.selectedStepCard, i, 'TITLE');
        card.comments = this.generateSopSubStepKey(this.selectedStepCard, i, 'COMMENT');
      });

      this.childData.emit({ key: 'saveSOP' });
    } else {
      if (this.sopStep.stepCards.length >= 1) {
        for (let i = 1; i <= this.sopStep.stepCards.length - 1; i++) {
          if (this.sopStep.stepCards[i].stepTittle !== '' || this.sopStep.stepCards[i].stepImage != null) {
            this.Retainsubstep = true;
          }
        }
        if (this.Retainsubstep) {
          this.modalRef2 = this.modalService.show(this.confirmModal, Object.assign({}, { class: 'w-420' }));
        }
      }
      this.sopStep.useStepImage = 0;
      this.sopStep.stepCards = [this.sopStep.stepCards[0]];

      this.sopStep.stepCards[0].stepTittle = this.generateSopStepKey(this.selectedStepCard, 'TITLE');
      this.sopStep.stepCards[0].comments = this.generateSopStepKey(this.selectedStepCard, 'COMMENT');

      if (!this.Retainsubstep) {
        this.childData.emit({ key: 'saveSOP' });
      }
    }
  }

  saveSingleSOP() {
    this.toggleSingleSOP();
  }

  updateSingleSOP() {
    this.isSubprocess = this.sopStep.stepType;

    let subProcTitlReqErr = false;
    let stepTitleReqErr = false;
    let stepImageReqErr = false;
    this.updateSubmitted = false;
    if (this.modelSubProcessTitle) {
      if (this.modelSubProcessTitle.invalid) {
        if (this.modelSubProcessTitle.errors.required) {
          subProcTitlReqErr = true;
          this.updateSubmitted = true;
        }
      }
    }
    this.modelStepTittle.forEach((stepTittle, index) => {
      if (stepTittle.invalid) {
        if (stepTittle.errors.required) {
          stepTitleReqErr = true;
        }
        this.updateSubmitted = true;
      }

      if (!this.sopStep.stepCards[index].stepImage) {
        stepImageReqErr = true;
        this.updateSubmitted = true;
      }

    });
    if (this.updateSubmitted) {
      if (subProcTitlReqErr || stepTitleReqErr) { this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.STEP_TITLE_ALL')); }
      if (stepImageReqErr) { this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.STEP_IMAGE_ALL')); }
      return false;
    }
    this.isUpdate = true;
    this.isSubStep = false;
    //  this.currentSOPsteps = this.sopStep.stepCards;
    if (this.sopStep.stepType) {
      this.toggleSingleSOP();
    } else {
      this.closePopup();
    }
  }

  displayNone(event) {
    const tooltipModal: HTMLElement = document.getElementById('sopimageTooltip');
    tooltipModal.style.cssText = 'display: none';
  }


  retainsubprocess() {
    this.sopStep.useStepImage = this.currentDefaultImage;
    this.sopStep.stepCards = this.currentSOPsteps;
    this.sopStep.stepType = true;
    this.childData.emit({ key: 'saveSOP' });
  }
  retainsinglestep() {
    this.service.subStepDisable = false;
    this.childData.emit({ key: 'saveSOP' });
  }

  selectImage(image, index, thisImage) {
    this.tooltipImage = image;
    this.activeClass = {};
    this.activeClass[index] = true;
    this.tooltipcloseMob = false;
    this.tooltipMaskMob = true;

    if (this.ImageIndex != null) {
      this.sopStep.stepCards[this.ImageIndex].stepImage = image.imageURL;
      this.sopStep.stepCards[this.ImageIndex].isInstitutionImage = false;
      const value = {
        key: 'stepImage',
        value: image.imageURL,
        stepIndex: this.ImageIndex
      };
      this.childData.emit(value);

    } else {
      const value = {
        key: 'image',
        value: image.imageURL
      };
      this.childData.emit(value);
    }
  }


  selectUserImage(image, index, thisImage) {
    this.tooltipImage = image;
    this.activeClass = {};
    this.activeClass[index] = true;
    this.tooltipcloseMob = false;
    this.tooltipMaskMob = true;

    if (this.ImageIndex != null) {
      this.sopStep.stepCards[this.ImageIndex].stepImage = image.imageURL;
      this.sopStep.stepCards[this.ImageIndex].isInstitutionImage = true;
    } else {
      let value = {
        key: 'userImage',
        value: image.imageURL
      };
      this.childData.emit(value);
    }
  }

  mobTooltipClose() {
    this.tooltipcloseMob = true;
    this.tooltipMaskMob = false;
  }

  addStack() {
    const subStepIndex = this.sopStep.stepCards.length;
    const stepCard = stepCards();
    stepCard.stepTittle = this.generateSopSubStepKey(this.selectedStepCard, subStepIndex, 'TITLE');
    stepCard.comments = this.generateSopSubStepKey(this.selectedStepCard, subStepIndex, 'COMMENT');
    this.sopStep.stepCards.push(stepCard);
    this.childData.emit({ key: 'saveSOP' });
  }

  openDeleteModal(deletemodal: TemplateRef<any>) {
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    );
  }
  openSubDeleteModal(subdelmodal: TemplateRef<any>, index) {

    this.deleteSubIndex = index;

    this.modalRef = this.modalService.show(subdelmodal, Object.assign({}, { class: 'w-420' })
    );
  }
  deleteSubProcess() {
    this.sopStep.stepCards.splice(this.deleteSubIndex, 1);
    if (this.deleteSubIndex == this.sopStep.useStepImage) {
      this.sopStep.useStepImage = 0;
    } else {
      this.sopStep.useStepImage = this.sopStep.stepCards.length - 1;
    }

    this.deleteSubIndex = undefined;
    if (this.sopStep.stepCards.length == 1) {
      this.sopStep.stepType = false;
    }

    if (this.sopStep.stepCards.length < 2) {
      this.isSubStep = false;
      this.sopStep.stepType = false;
      this.service.subStepDisable = false;
      this.sopStep.useStepImage = 0;
    }

    this.childData.emit({ key: 'saveSOP' });
  }
  openDeleteImageModal(deletemodal: TemplateRef<any>, index) {
    this.index = index;
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    );
  }
  deleteImage() {
    this.sopStep.stepCards[this.index].stepImage = null;
  }
  removeSOP() {
    let data = { key: 'remove', isSubStep: this.sopStep.stepType };
    this.childData.emit(data);
    this.closePopup();

    this.childData.emit({ key: 'saveSOP' });
  }

  openCamera() {
    this.modalService._hideModal(1);
    this.modalService._hideBackdrop();
    this.childData.emit({ key: 'openCamera' });
  }

  cancelChooseImage() {
    if (this.previousData && this.previousData.index != null) {
      this.sopStep.stepCards[this.previousData.index].stepImage = this.previousData.image;
    }
    this.childData.emit({ key: 'cancelImage' });
    this.modalRef.hide();
  }

  chooseImage() {
    this.modalRef.hide();
    // this.updateSingleSOP();
    this.childData.emit({ key: 'saveSOP' });
  }

  commonChecked() {
    this.childData.emit({ key: 'saveSOP' });
  }

  generateSopStepKey(stepIndex: number, field: string): string {
    return `SOP_${this.sopId}_${this.sopVersionNo}.STEPS.STEP_${stepIndex}.${field}`;
  }

  generateSopSubStepKey(stepIndex: number, subStepIndex: number, field: string): string {
    return `SOP_${this.sopId}_${this.sopVersionNo}.STEPS.STEP_${stepIndex}.SUBSTEPS.STEP_${subStepIndex}.${field}`;
  }

  updateInputs(index: number) {

    if (!this.isSubStep) {
      this.sopStep.stepCards.forEach((card) => {
        card.stepTittle = this.generateSopStepKey(index, 'TITLE');
        card.comments = this.generateSopStepKey(index, 'COMMENT');
      });
    } else {
      this.sopStep.stepCards.forEach((card, i) => {
        card.stepTittle = this.generateSopSubStepKey(index, i, 'TITLE');
        card.comments = this.generateSopSubStepKey(index, i, 'COMMENT');
      });
    }
  }

  errImg(e: Event) {
    e.target['src'] = 'assets/img/fallback-img.png';
  }

  showDefaultButton(sopStep, viewType) {
    console.log(sopStep, viewType);
    return sopStep.stepType && viewType != 'view';
  }

}
